import { gql } from '@apollo/client';
import { BaseDepositFragmentDoc } from './BaseDeposit.generated';
import { BaseTransactionFragmentDoc } from './BaseTransaction.generated';
import { BaseUserFragmentDoc } from './BaseUser.generated';
import type * as Types from './Types';

export type FullUserFragment = {
  username?: string | null;
  fullname?: string | null;
  birthdate?: string | null;
  source?: Types.SourceOfFunds | null;
  createdAt: string;
  investedUSD: number;
  stripeId?: string | null;
  _id: string;
  email: string;
  admin: boolean;
  address?: { line1: string; line2: string; line3: string; zip: string; city: string; countryCode: string } | null;
  company?: { name: string; phone: string; countryCode: string } | null;
  kyc: {
    tier: number;
    identity: { status: Types.VerificationStatus };
    document: { status: Types.VerificationStatus };
    boardMeeting: { status: Types.VerificationStatus };
  };
  state: {
    termsAccepted?: boolean | null;
    closeMigrationAlert?: boolean | null;
    acceptedNewTerms?: boolean | null;
    bonusDPS?: boolean | null;
    eligibleToBonusDPS: boolean;
  };
  wallet?: { address: string; balance_wDPS?: string | null } | null;
  referral: {
    code: string;
    refereeCount: number;
    gains?: string | null;
    referrer?: { _id: string; fullname?: string | null; email: string; referral: { code: string } } | null;
    details: Array<{ referred: { _id: string; fullname?: string | null; email: string; referral: { code: string } } }>;
  };
  twoFA: { otp: boolean };
  deposits: Array<{
    _id: string;
    amount: number;
    currency: Types.FiatCurrency;
    status: Types.DepositStatus;
    method: Types.DepositMethod;
    createdAt: string;
    wallet: string;
    user: { _id: string; email: string };
  }>;
  agreement: { id?: string | null; status: Types.AgreementStatus };
  transactions: Array<{
    _id: string;
    blockNumber: number;
    amount: string;
    rate: number;
    timestamp: string;
    transactionId: string;
    avaxAmount?: string | null;
    from: string;
  }>;
};

export const FullUserFragmentDoc = /*#__PURE__*/ gql`
  fragment FullUser on User {
    ...BaseUser
    username
    fullname
    birthdate
    source
    address {
      line1
      line2
      line3
      zip
      city
      countryCode
    }
    company {
      name
      phone
      countryCode
    }
    kyc {
      tier
      identity {
        status
      }
      document {
        status
      }
      boardMeeting {
        status
      }
    }
    state {
      termsAccepted
      closeMigrationAlert
      acceptedNewTerms
      bonusDPS
      eligibleToBonusDPS
    }
    wallet {
      address
      balance_wDPS
    }
    referral {
      code
      referrer {
        _id
        fullname
        email
        referral {
          code
        }
      }
      details {
        referred {
          _id
          fullname
          email
          referral {
            code
          }
        }
      }
      refereeCount
      gains
    }
    twoFA {
      otp
    }
    createdAt
    deposits {
      ...BaseDeposit
    }
    agreement {
      id
      status
    }
    transactions {
      ...BaseTransaction
    }
    investedUSD
    stripeId
  }
  ${BaseUserFragmentDoc}
  ${BaseDepositFragmentDoc}
  ${BaseTransactionFragmentDoc}
`;
